"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGTAGInitialized = exports.injectGATags = exports.createVirtualPageViewGA4 = exports.createEventGA4 = exports.Methods = void 0;
var _analytics = require("./analytics");
var _array = require("./type-checks/array");
var _function = require("./type-checks/function");
var _string = require("./type-checks/string");
/**
 * Initiate a GoogleTag event
 *
 * @name createEventGA4
 * @param {string} [eventName="customEvent"] Name of injected event
 * @param {object} [analyticsEventData={}] Optional object to pass data to Google Tags
 */
const createEventGA4 = function () {
  let eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "customEvent";
  let analyticsEventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let result = false;
  if ((0, _function.isFunction)(window.gtag)) {
    result = window.gtag("event", eventName, analyticsEventData);
  }
  return result;
};

/**
 * Event to record all PWA app virtual page requests
 *
 * @name createVirtualPageViewGA4
 * @param {string} [eventName="virtualPageview"] Name of injected event
 * @param {object} [analyticsEventData={}] Optional object to pass data to Google Tags
 */
exports.createEventGA4 = createEventGA4;
const createVirtualPageViewGA4 = function () {
  let eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "virtualPageview";
  let analyticsEventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _analytics.Methods.createEventGA4(eventName, analyticsEventData);
};

/**
 * Injects Google Tags configuration into a web view
 *
 * @name injectGATags
 * @param {string} googleId Google Tags ID Number
 */
exports.createVirtualPageViewGA4 = createVirtualPageViewGA4;
const injectGATags = googleId => {
  const protocol = (0, _string.isStringOfLength)(window?.location?.protocol) ? window.location.protocol : "https:",
    scriptLoader = document?.createElement("script");
  let result = false;
  if (!(0, _function.isFunction)(window?.gtag) && (0, _string.isStringOfLength)(googleId)) {
    scriptLoader.setAttribute("async", "async");
    scriptLoader.setAttribute("defer", "defer");
    scriptLoader.setAttribute("src", `${protocol}//www.googletagmanager.com/gtag/js?id=${googleId}`);
    scriptLoader.addEventListener("load", () => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        return window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", googleId);
    });
    result = document?.head?.appendChild(scriptLoader);
  }
  return result;
};

/**
 * Method to test if Google Tags is initialized
 *
 * @name isGTAGInitialized
 * @returns {boolean} Indicator if Google Tags has been initialized
 */
exports.injectGATags = injectGATags;
const isGTAGInitialized = () => {
  const scriptRegExp = /googletagmanager\.com\/gtag/gi,
    scriptCollection = document.querySelectorAll("script");
  let isInstantiated = (0, _function.isFunction)(window.gtag) && (0, _array.isArray)(window.dataLayer);
  if (!isInstantiated) {
    Array.prototype.every.call(scriptCollection, scriptNode => {
      isInstantiated = scriptRegExp.test(scriptNode.src);
      return !isInstantiated;
    });
  }
  return isInstantiated;
};
exports.isGTAGInitialized = isGTAGInitialized;
const Methods = exports.Methods = {
  createEventGA4: createEventGA4,
  createVirtualPageViewGA4: createVirtualPageViewGA4,
  injectGATags: injectGATags,
  isGTAGInitialized: isGTAGInitialized
};